import { createContext, useContext, useEffect, useState } from 'react';

const CMSPreviewContext = createContext({ enabled: false, content: {}, slug: null });

export function CMSPreviewProvider({ children }) {
  const [enabled, setEnabled] = useState(false);
  const [content, setContent] = useState({});
  const [slug, setSlug] = useState(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    const isPreview = params.get('cms_preview') === '1';
    setEnabled(isPreview);
    if (!isPreview) return;

    const handler = (e) => {
      const data = e.data || {};
      if (data.type !== 'gems-cms-preview') return;
      const map = {};
      (data.sections || []).forEach((s) => {
        map[s.id] = {};
        (s.fields || []).forEach((f) => { map[s.id][f.key] = f.value; });
      });
      setSlug(data.slug);
      setContent(map);
    };
    window.addEventListener('message', handler);
    // tell parent we are ready
    try { window.parent?.postMessage({ type: 'gems-cms-preview-ready' }, '*'); } catch (e) { /* ignore */ }
    return () => window.removeEventListener('message', handler);
  }, []);

  return (
    <CMSPreviewContext.Provider value={{ enabled, content, slug }}>
      {children}
    </CMSPreviewContext.Provider>
  );
}

export function useCMSPreview() {
  return useContext(CMSPreviewContext);
}

// helper: return preview value when in preview mode, otherwise fallback
export function usePreviewValue(sectionId, fieldKey, fallback) {
  const { enabled, content } = useCMSPreview();
  if (enabled && content[sectionId] && content[sectionId][fieldKey] !== undefined && content[sectionId][fieldKey] !== '') {
    return content[sectionId][fieldKey];
  }
  return fallback;
}
